import { formatCustomDate } from "helpers/dateTools";

export const initialValues = {
  values: {
    date: formatCustomDate(new Date(), '-'),
    idStation: null,
    idUnit: null,
    unitsOpt: [],
    searchCustomer: '',
    idAccount: null,
    customersOpt: [],
    productsOpt: [],
    product: null,
    quantity: 0,
    cil10: 0,
    cil20: 0,
    cil30: 0,
    cil45: 0,
    kgs: 0,
    kgsCil: 0,
    lts: 0,
    total: 0,
    unitPriceLt: 0,
    unitPriceKg: 0,
    tax: 0,
    discount: 0,
    idPayment: null,
    paymentsOpt: [],
    sgcSelected: null,
    totalByProduct: 0,
    blockCredit: false,
    balance: 0,
    withholding: 0,
    retentionsTotal: 0,
    efe: 0

  },
  required: {
    date: { required: true },
    idStation: { required: true },
    idUnit: { required: true },
    idAccount: { required: true },
    idPayment: { required: true },
    sgcSelected: { required: true }
  }
}